<template>
    <v-flex fill-height>
        <sidemainmenu/>
        <br />
        <v-progress-linear slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
        </v-alert>
        <v-alert :value="alerterror" color="error" icon="new_releases">
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </v-alert>
        <v-layout wrap justify-space-between>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-layout wrap justify-space-between>
                    <v-flex xs12 md2>
                        <v-menu v-model="dtSfromdate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="dtsfrdate" label="From Date" prepend-icon="event" readonly
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dtsfrdate" @input="dtSfromdate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 md2>
                        <v-menu v-model="dtStodate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="dtstdate" label="To Date" prepend-icon="event" readonly
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dtstdate" @input="dtStodate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="py-2">
                        <v-btn color="info" v-on:click="getData()">
                            <span>Search</span>
                            <v-icon>search</v-icon>
                        </v-btn>
                        <v-btn color="success" v-on:click="seen = !seen">
                            <span>Add New / List</span>
                            <v-icon>add</v-icon>
                        </v-btn>
                        <v-btn color="error" v-on:click="clearData()">
                            <span>Clear</span>
                            <v-icon>loop</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 md2>
                        <h3 class="py-4">FCL GATE OUT</h3>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        <export-excel
                            title = "VCFS FCL Gate Out"
                            :data   = "fcl_details">
                            <v-btn color="cyan">
                            <v-icon color="white">file_copy</v-icon>
                        </v-btn>
                        </export-excel>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="fcl_details" :search="search" class="elevation-1" :rows-per-page-items="[15, 10, 30, 40]">
                        <template v-slot:items="props">
                            <td>{{ props.index + 1 }}</td>
                            <td v-on:click="passPrint(props.item.gateout_id)"><v-icon >print</v-icon></td>
                            <td class="text-xs-right">{{ props.item.cont_no }}</td>
                            <td class="text-xs-right">{{ props.item.sizetype }}</td>
                            <td class="text-xs-right">{{ props.item.out_time }}</td>
                            <td class="text-xs-right">{{ props.item.pass_no }}</td>
                            <td class="text-xs-right">{{ props.item.seal_no }}</td>
                            <td class="text-xs-right">{{ props.item.line_seal }}</td>
                            <td class="text-xs-right">{{ props.item.customer }}</td>
                            <td class="text-xs-right">{{ props.item.payment.type }}</td>
                            <td class="text-xs-right">{{ props.item.igm_no }}</td>
                            <td class="text-xs-right">{{ props.item.igm_date }}</td>
                            <td class="text-xs-right">{{ props.item.cont_ref_no }}
                            </td>
                            <td class="text-xs-right">{{ props.item.bl_no }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card  v-else>
                    <v-form v-model="valid" ref="form">
                    <v-card-text class="mx-auto">
                        <v-container grid-list-xl>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtScont_no" label="Search By Container No." :rules="[(v) => !!v || 'Container No is required']" autofocus :counter="11" autocapitalize="words" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-btn  color="info" v-on:click="getSContData()">Search<v-icon right dark>search</v-icon></v-btn>
                                </v-flex>
                            </v-layout>
                            <v-card justify-center>
                                <v-card-text v-for="(container, index) in cont_list" v-bind:key="index" primary-title>
                                    <v-layout>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" container.bl_no" label="BL No" readonly readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" container.cont_no" label="Container No" readonly readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" container.gin_date | formatDate" label="Gate In Date" readonly readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" container.line" label="Line" readonly readonly></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" container.size_type" label="Size Type" readonly readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" container.package" label="Package" readonly readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" container.weight" label="weight" readonly readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field :value=" container.age" label="Age" readonly readonly></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md3>
                                    <v-text-field v-model="txttruckno" label="Truck No" :rules="[(v) => !!v || 'Truck No is required']" ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field v-model="txtseal_no" label="Seal No."   :rules="[(v) => !!v || 'Seal No is required']" ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field v-model="txtline_seal" label="Line Seal No."></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select v-model="cbopayment_mode" :items="payment_mode" item-value="id" item-text="text"  :rules="[(v) => !!v || 'Payment Mode is required']" @change="onChange()" label="Select Payment Mode"></v-select>
                                </v-flex>
                            </v-layout>
                            <v-card v-if="is_chequepay" justify-center color="cyan lighten-4" class="white --text">
                                <v-card-text primary-title>
                                    <v-layout>
                                        <v-flex xs12 md3>
                                            <v-text-field v-model="txtcheque_no" label="Cheque No" required ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-menu v-model="dpcdate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="dtcdate" label="Cheque Date" prepend-icon="event" readonly
                                            v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dtcdate" @input="dpcdate = false"></v-date-picker>
                                        </v-menu>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field v-model="txtbank_name" label="Bank Name" required ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-text-field v-model="txtamount" label="Amount"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md9>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-btn color="success" v-bind:disabled="btnDisable" v-on:click="submitData()">Save</v-btn>
                                    <v-btn color="error" v-on:click="clearData()">Clear</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-form>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus/>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import DatetimePicker from 'vuetify-datetime-picker';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'fcl',
    data() {
        return {
            error: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            seen: true,
            search: null,
            fcl_details: [],
            cont_list: [],
            bls: [],
            dtsfrdate: null,
            dtstdate: null,
            dtcdate: new Date().toISOString().substr(0, 10),
            dpcdate: false,
            activeVal: "Open",
            btnDisable: false,
            is_chequepay: false,
            loading: false,
            dtSfromdate: false,
            dtStodate: false,
            txtScont_no: null,
            txtsblno: null,
            txtsigm: null,
            txtsline: null,
            txtssizetype: null,
            txtsgindate: null,
            txtspackage: null,
            txtsweight: null,
            txtsage: null,
            txttruckno: null,
            txtseal_no: null,
            txtline_seal: null,
            cbopayment_mode: null,
            txtcheque_no: null,
            txtamount: null,
            txtbank_name: null,
            txttot_ass_value: null,
            txtdutyamount: null,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            search: '',
            headers: [
              { text: 'S.No', sorting: false, align: 'left' },
              { text: 'Print', align: 'left', value: 'gateout_id' },
              { text: 'Container No.', align: 'right', value: 'cont_no' },
              { text: 'Size Type', align: 'right', value: 'sizetype' },
              { text: 'GOut Date', align: 'right', value: 'out_time' },
              { text: 'Pass No', align: 'right', value: 'pass_no' },
              { text: 'Seal No', align: 'right', value: 'seal_no' },
              { text: 'Line Seal', align: 'right', value: 'line_seal' },
              { text: 'Customer', align: 'right', value: 'customer' },
              { text: 'Payment Tye', align: 'right', value: 'payment.type' },
              { text: 'IGM', align: 'right', value: 'igm_no' },
              { text: 'IGM Date', align: 'right', value: 'igm_date' },
              { text: 'BL', align: 'right', value: 'bl_no' },
              { text: 'Work Order', align: 'right', value: 'cont_ref_no' }
            ],
            payment_mode: [
                {
                  text: 'CHEQUE',
                  id: 3
                },
                {
                  text: 'CREDIT',
                  id: 2
                },
                {
                  text: 'CASH',
                  id: 1
                }
            ]
        }
    },
    mounted:function(){
        this.getData()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        getData: function () {
            this.loading = true;
            if(this.dtsfrdate !== null && this.dtstdate !== null) {
                this.API_URL = this.$hostname + "/fcl_gateouts?from_date=" + this.dtsfrdate + "&to_date=" + this.dtstdate
            } else {
                this.API_URL = this.$hostname + "/fcl_gateouts?limit=15"
            }
            // this.API_URL = this.$hostname + "/fcl_gateouts?limit=15"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.fcl_details = response.data;
            }, (error) => {
                this.loading = false;
                this.error = error.response.data.result;
                alert(this.error);
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        },
        submitData: function() {
            if(!this.$refs.form.validate()) {
                return false
            }
            this.btnDisable = true;
            this.loading = true;
            const fcl_goutdata = {'crossDomain': true,
                                  'cont_id': this.cont_list[0].cont_id,
                                  'truck_no': this.txttruckno,
                                  'seal_no': this.txtseal_no,
                                  'line_seal': this.txtline_seal,
                                  'payment': this.cbopayment_mode,
                                  'created_by': localStorage.username}
            const data = {
                "gout_data": fcl_goutdata,
            }
            if (this.cbopayment_mode === 3) {
                data['payment_data'] = {
                    'cheque_no': this.txtcheque_no,
                    'check_date': this.dtcdate,
                    'bank_name': this.txtbank_name,
                    'amount': this.txtamount,
                }
            }
            axios.post(this.$hostname + '/fcl_gateouts', data,
                       { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
                 .then(response => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alertsuccess = "Container was Gate Out Successfully";
                    window.location.reload();
                 }, (error) => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alerterror = error.response.data.message;
                    alert("this.alerterror");
                    window.location.reload();
                })
        },
        getSContData: function () {
            if (this.txtScont_no === null) {
                alert("Please Enter Container Number");
            } else {
                this.API_URL = this.$hostname + "/search_fcl_containers/" + this.txtScont_no
                this.loading = true;
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.cont_list = response.data.result;
                this.loading = false;
            }, (error) => {
                this.errors = error.response.data.message;
                this.loading = false;
                alert(this.errors);

            })
        },
        onChange() {
            if (this.cbopayment_mode === 3) {
                this.is_chequepay = true;
            } else {
                this.is_chequepay = false;
            }
        },
        clearData: function() {
            this.dtSfromdate = null;
            this.dtStodate = null;
            this.dtSfromdate = false;
            this.dtStodate = false;
            this.txtScont_no = null;
            this.txtsblno = null;
            this.txtsigm = null;
            this.txtsline = null;
            this.txtssizetype = null;
            this.txtsgindate = null;
            this.txtspackage = null;
            this.txtsweight = null;
            this.txtsage = null;
            this.txttruckno = null;
            this.txtseal_no = null;
            this.txtline_seal = null;
            this.cbopayment_mode = null;
        },
        passPrint: function(goutID) {
            let passPage = this.$router.resolve('/fclpass/' + goutID);
            window.open(passPage.href, '_blank');
        }
    }
  }
</script>

<style lang="stylus" scoped>
      .v-progress-circular
        margin: 1rem
    .loading-overlay 
        z-index: 10
        top: 0
        left: 0
        right: 0
        position: absolute
        width: 100%
        height: 100%
        background: rgba(255, 255, 255, 0.9)
        display: flex
        align-items: center
        justify-content: center
      
</style>
